export interface CalculatorCourseProps {
  courseCode: string;
  courseName: string;
  coursePoint: number;
  grade: number;
}

export interface CalculatorSemesterProps {
  semester: string;
  calculatorCourses: CalculatorCourseProps[];
  grade: number;
}

export const gradeValues: { [key: string]: number } = {
  A: 5,
  B: 4,
  C: 3,
  D: 2,
  E: 1,
  F: 0,
  Bestått: -1,
};
